jQuery(document).ready(function($) {

  $('.test-slider').slick({
    arrows: true,
    dots: true,
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          centerPadding: '5%',
          arrows: false,
          dots: true,
          autoplaySpeed: 5000,
          pauseOnHover: false,
          pauseOnFocus: false
        },
      },
    ]
  });

  $('.tips-slider').slick({
    arrows: true,
    dots: true,
    // autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerPadding: '5%',
          arrows: true,
          dots: true,
        },
      },
    ]
  });

});